import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42b92a0a")

_pushScopeId("data-v-42b92a0a")
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Report a Bug", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", null, " I never wanted it to come to this. "),
  /*#__PURE__*/_createVNode("p", null, " Please select which application has a bug. ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_AppCard = _resolveComponent("AppCard")
  const _component_AppGrid = _resolveComponent("AppGrid")
  const _component_Navigation = _resolveComponent("Navigation")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode(_component_Navigation, null, {
      default: _withId(() => [
        _hoisted_2,
        _createVNode(_component_router_view),
        _hoisted_3,
        _createVNode(_component_AppGrid, null, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Applications, ({appName}, appKey) => {
              return (_openBlock(), _createBlock(_component_AppCard, {
                key: `report-bug-${appKey}`,
                to: _ctx.generateDynamicPath(_ctx.Paths.REPORT_BUG, appKey)
              }, {
                default: _withId(() => [
                  _createVNode("h3", null, _toDisplayString(appName), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})